module.exports = __webpack_public_path__ + "img/pre_sale.528fa986.svg";